import { Injectable } from '@angular/core';

@Injectable()
export class TimeService {
	constructor(
	) {

	}

	secondsToSMPTE(seconds: number, fps = 25) {
		const ret: any = {};
		ret.f = Math.floor((seconds % 1) * fps) || '00';
		ret.s = Math.floor(seconds);
		ret.m = Math.floor(ret.s / 60);
		ret.h = Math.floor(ret.m / 60);
		ret.m = ret.m % 60;
		ret.s = ret.s % 60;
		ret.ms = Math.floor((seconds % 1) * 1000);

		return ret;
	}

	SMPTEToString(timecode: any, forceHourDisplay = false, hideSeconds = false, hideFrames = false, useMilliseconds = false) {
		let timeString = '';
		// optional hh:
		timeString += timecode.h || forceHourDisplay ? (timecode.h < 10 ? '0' + timecode.h : timecode.h) + ':' : '';

		// mm:ss
		timeString += timecode.m < 10 ? '0' + timecode.m : timecode.m;
		if (!hideSeconds) {
			timeString += ':';
			timeString += timecode.s < 10 ? '0' + timecode.s : timecode.s;
			// optional .ff (frameNumber)
			let ms2chars: any = Math.round(timecode.ms / 10);
			if (ms2chars < 10) {
				ms2chars = '0' + ms2chars;
			}
			timeString += useMilliseconds ? '.' + ms2chars : (!hideFrames && timecode.f ? '.' + (timecode.f < 10 ? '0' + timecode.f : timecode.f) : '');
		}

		return timeString;
	}

	secondsToTimeString(seconds: number, forceHourDisplay = false, fps = 25, hideSeconds = false, hideFrames = false, useMilliseconds = false): string {
		seconds = Number(seconds);
		return this.SMPTEToString(this.secondsToSMPTE(seconds + 0.000000001, fps), forceHourDisplay, hideSeconds, hideFrames, useMilliseconds); // stupid javascript floating points...
	}

	timeStringToSeconds(timeString: string, fps = 25, useMilliseconds = false): number {
		const a = timeString.split(':').map(n => Number(n));
		while (a.length < 3) {
			a.unshift(0);
		}

		if (useMilliseconds) {
			const s = a[0] * 60 * 60 + a[1] * 60 + a[2];
			return s;
		}

		let frameBelow10 = false;
		const floatPart = timeString.split('.')[1];
		if (floatPart) {
			frameBelow10 = floatPart.length === 1;
		}

		const ms = a[2] - Math.floor(a[2]);
		let frame = Number(ms.toFixed(2).split('.')[1]);
		if (frameBelow10) {
			frame /= 10;
		}

		a[2] = Math.floor(a[2]) || 0;
		// minutes are worth 60 seconds. Hours are worth 60 minutes.
		let seconds = a[0] * 60 * 60 + a[1] * 60 + a[2];

		if (frame) {
			seconds = Math.floor(seconds) + (frame / fps);
		}
		return seconds;
	}

}
